<template>
  <div id="app" class="full-height">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style></style>
